import {
  BrowserOptions,
  captureConsoleIntegration,
  extraErrorDataIntegration,
  httpClientIntegration,
  reactRouterV7BrowserTracingIntegration,
} from '@sentry/react';
import React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import { beforeSend } from '../functions/beforeSend';
import { getRelease } from '../functions/getRelease';
import { getTracesSampleRate } from '../functions/getTracesSampleRate';

export const sentryOptions: BrowserOptions = {
  beforeSend,
  debug: false,
  dsn: 'https://20adc36c08104533969c4807d9169de5@o92107.ingest.sentry.io/1398689',
  environment: import.meta.env.VITE_APP_ENV,
  ignoreErrors: ['t.blacklistC'],
  integrations: [
    reactRouterV7BrowserTracingIntegration({
      createRoutesFromChildren,
      matchRoutes,
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
    }),
    captureConsoleIntegration({ levels: ['error'] }),
    extraErrorDataIntegration(),
    httpClientIntegration(),
  ],
  release: getRelease(),
  sendDefaultPii: true,
  tracesSampleRate: getTracesSampleRate(),
};
